import { Injectable } from '@angular/core';
import { SavedFilterEntity } from '../../domain/entities/saved-filter.entity';
import { SavedFilterResponseDto } from '../dtos/saved-filter-response.dto';

@Injectable({ providedIn: 'root' })
export class SavedFiltersMapper {
  public toDomain(dto: SavedFilterResponseDto): SavedFilterEntity {
    const entity = new SavedFilterEntity();
    entity.id = dto.id;
    entity.name = dto.name;
    entity.description = dto.description ?? null;
    entity.filter = dto.filter;
    entity.isSystem = dto.isSystem;
    entity.isActive = dto.isActive;
    entity.displayOrder = dto.displayOrder;
    entity.count = dto.count;
    return entity;
  }

  public toDomainArray(dtos: SavedFilterResponseDto[]): SavedFilterEntity[] {
    return dtos.map((dto) => this.toDomain(dto));
  }
}
